module.exports = __webpack_public_path__ + "static/media/Pic-0395.4a098fa5.jpg";